import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import PageHeadline from "../PageHeadline/PageHeadline";
import NewCaseCard from "./NewCaseCard";
import { mercureSubscribe } from "../../services/mercure";
import _ from "lodash";
import ApiClient from "../../services/ApiClient";
import { BackofficeCase } from "../../types/BackofficeCase";
import { getPartnerIri, isKnownPartner } from "../../services/partnerReferenceService";
import usePartnerRegistry from "../../hooks/usePartnerRegistry";

export default function NewCases() {
  const [backofficeCases, setBackofficeCases] = useState([]);
  const [newBackofficeCase, setNewBackofficeCase] = useState<Record<string, any>>({});
  const { partnersBySlug, isLoading: isPartnerRegistryLoading } = usePartnerRegistry();
  const wbsPartnerIri = getPartnerIri(partnersBySlug.wbs);

  useEffect(() => {
    return  mercureSubscribe("/cases/new", setNewBackofficeCase);
  }, []);

  useEffect(() => {
    if (!wbsPartnerIri) {
      return;
    }

    const query = `backoffice_cases?order[id]=desc&acquisitionPartner[not_identical]=${encodeURIComponent(
      wbsPartnerIri
    )}`;
    ApiClient.get(query).then((result) => {
      setBackofficeCases(result["hydra:member"].slice(0, 5));
    });
  }, [wbsPartnerIri]);

  useEffect(() => {
    if (!_.isEmpty(newBackofficeCase)) {
      appendNewBackofficeCase(newBackofficeCase);
    }
  }, [newBackofficeCase]);

  const appendNewBackofficeCase = (backofficeCase: any) => {
    if (isKnownPartner(backofficeCase.acquisitionPartner, "wbs")) {
      return;
    }
    let newBoCases = [backofficeCase, ...backofficeCases.slice(0, 4)];
    // @ts-ignore
    setBackofficeCases(newBoCases);
  };

  if (isPartnerRegistryLoading) {
    return null;
  }

  return (
    <>
      <PageHeadline main="Neue Fälle" />
      <Stack
        spacing={3}
        sx={{
          alignItems: "center",
          width: "100%"
        }}>
        {_.map(backofficeCases, (backofficeCase: BackofficeCase) => (
          <NewCaseCard key={backofficeCase.id} backofficeCase={backofficeCase} />
        ))}
      </Stack>
    </>
  );
}
